import './generateToast.65cbb8f7f2ac63ce2a3edf448795b230.css';
export default {"toast":"_toast_12oi2_1","info":"_info_12oi2_1","success":"_success_12oi2_1","hint":"_hint_12oi2_1","error":"_error_12oi2_1"};